import { countries } from "countries-list";

const currencyModule = {
  currenciesCodes: [
    "AED",
    "ARS",
    "AUD",
    "BDT",
    "BOB",
    "BRL",
    "CAD",
    "CHF",
    "CLP",
    "CNY",
    "COP",
    "CRC",
    "CZK",
    "DKK",
    "DZD",
    "EGP",
    "EUR",
    "GBP",
    "GTQ",
    "HKD",
    "HNL",
    "HUF",
    "IDR",
    "ILS",
    "INR",
    "ISK",
    "JPY",
    "KES",
    "KRW",
    "MOP",
    "MXN",
    "MYR",
    "NGN",
    "NIO",
    "NOK",
    "NZD",
    "PEN",
    "PHP",
    "PKR",
    "PLN",
    "PYG",
    "QAR",
    "RON",
    "RUB",
    "SAR",
    "SEK",
    "SGD",
    "THB",
    "TRY",
    "TWD",
    "USD",
    "UYU",
    "VEF",
    "VND",
    "ZAR",
  ],
  countries: Object.entries(countries).map(([code, value]) => ({
    code,
    name: value.name,
    phone: value.phone,
  })),
};

export default currencyModule;
